import React from "react";

import { DatePickerInputProps, DatePickerProps } from "types";

import DatePicker from ".";


const DatePickerCommon = ({
	name,
	value,
	placeholderText,
	className,
	wrapperClassName,
	onChange,
	onBlur,
	onFocus,
	minDate,
	maxDate,
	tabIndex,
	disabled,
}: DatePickerInputProps & DatePickerProps) => {
	return (
		<DatePicker
			name={name}
			value={value}
			dateFormat="MM/dd/yyyy"
			onChange={onChange}
			onBlur={onBlur}
			onFocus={onFocus}
			placeholderText={placeholderText}
			className={className}
			wrapperClassName={wrapperClassName}
			minDate={minDate}
			maxDate={maxDate}
			tabIndex={tabIndex}
			disabled={disabled}
		/>
	);
};

export default DatePickerCommon;
